// Service para conectar con la API de listas de regalos

// const API_BASE_URL = 'http://localhost:3000/api';
const API_BASE_URL = 'https://app.inbook.es/api';

class ApiService {
  /**
   * Crear una nueva lista de regalos
   */
  async createList(listData) {

    try {
      const response = await fetch(`${API_BASE_URL}/lists`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(listData),
      });

      if (!response.ok) {
        const error = await response.json();
        console.error('❌ Error response:', error);
        throw new Error(error.error || 'Error al crear la lista');
      }

      const data = await response.json();
      return data;

    } catch (error) {
      console.error('❌ Error in createList:', error);
      console.error('Error details:', error.message);
      throw error;
    }
  }

  /**
   * Acceder a una lista (con verificación de contraseña si es necesario)
   */
  async accessList(listId, password = null, email = null, isAdmin = false) {

    try {
      const response = await fetch(`${API_BASE_URL}/lists/${listId}/access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          password,
          email,
          isAdmin,
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al acceder a la lista');
      }

      return await response.json();
    } catch (error) {
      console.error('Error accessing list:', error);
      throw error;
    }
  }

  /**
   * Actualizar información de la lista (solo administrador)
   */
  async updateList(listId, email, updateData) {
    try {
      const response = await fetch(`${API_BASE_URL}/lists/${listId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          ...updateData,
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al actualizar la lista');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating list:', error);
      throw error;
    }
  }

  /**
   * Eliminar lista (solo administrador)
   */
  async deleteList(listId, email) {
    try {
      const response = await fetch(`${API_BASE_URL}/lists/${listId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al eliminar la lista');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting list:', error);
      throw error;
    }
  }

  /**
   * Añadir un regalo a la lista (solo administrador)
   */
  async addGift(listId, email, giftData) {
    try {
      const response = await fetch(`${API_BASE_URL}/lists/${listId}/gifts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          ...giftData,
        }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al añadir el regalo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error adding gift:', error);
      throw error;
    }
  }

  /**
   * Reservar un regalo
   */
  async reserveGift(giftId, reserverName) {
    try {
      const response = await fetch(`${API_BASE_URL}/gifts/${giftId}/reserve`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ reserverName }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al reservar el regalo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error reserving gift:', error);
      throw error;
    }
  }

  /**
   * Eliminar un regalo (solo administrador)
   */
  async deleteGift(listId, giftId, email) {
    try {
      const response = await fetch(`${API_BASE_URL}/lists/${listId}/gifts/${giftId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al eliminar el regalo');
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting gift:', error);
      throw error;
    }
  }

  /**
   * Health check del servidor
   */
  async healthCheck() {
    try {
      const response = await fetch(`${API_BASE_URL}/health`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('❌ Health check failed:', error);
      throw error;
    }
  }
}

export default new ApiService();